import { render, staticRenderFns } from "./AlbumDetails.vue?vue&type=template&id=01af1767&scoped=true&"
import script from "./AlbumDetails.vue?vue&type=script&lang=ts&"
export * from "./AlbumDetails.vue?vue&type=script&lang=ts&"
import style0 from "./AlbumDetails.vue?vue&type=style&index=0&id=01af1767&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01af1767",
  null
  
)

export default component.exports